import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Link } from 'common/components/Link';
import { IOfferEventDateFragment } from 'graphql/types';

interface IProps {
    date: IOfferEventDateFragment;
    disabled?: boolean;
}

export const OfferEventDateLocation = ({ date, disabled }: IProps) => {
    const { location, locationString } = date;

    if (!location) {
        return (
            <Typography component="span" variant="body2">
                {locationString}
            </Typography>
        );
    }

    const { title, location: address } = location;

    const addressLink = address ? (
        <Box
            component={!disabled ? Link : 'span'}
            {...(!disabled && {
                href: `https://www.google.com/maps?q=${encodeURIComponent(
                    address
                )}`,
                target: '_blank',
            })}
        >
            {address}
        </Box>
    ) : null;

    return (
        <Typography component="span" variant="body2">
            {title}
            {title && address && ' - '}
            {addressLink}
        </Typography>
    );
};
